import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import client from '../lib/feathers';

export default function OutreachUnsubscribe() {
  const [searchParams] = useSearchParams();
  const cid = searchParams.get('cid');

  const [status, setStatus] = useState('loading'); // loading | confirm | success | already | error
  const [contact, setContact] = useState(null);

  useEffect(() => {
    if (!cid) {
      setStatus('error');
      return;
    }
    // Verify the contact exists
    const checkContact = async () => {
      try {
        const result = await client.service('industry/outreach-contact').patch(cid, { status: 'unsubscribed' });
        setContact(result);
        if (result.status === 'unsubscribed') {
          setStatus('success');
        }
      } catch (err) {
        if (err.code === 404) {
          setStatus('error');
        } else {
          setStatus('error');
        }
      }
    };
    checkContact();
  }, [cid]);

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
      <div className="max-w-md w-full bg-white rounded-lg shadow-md p-8 text-center">
        <div className="mb-6">
          <h1 className="text-2xl font-bold text-primary">VinoSeeker</h1>
        </div>

        {status === 'loading' && (
          <div>
            <p className="text-gray-600">Processing your request...</p>
          </div>
        )}

        {status === 'success' && (
          <div>
            <div className="mb-4 text-green-600">
              <svg className="w-16 h-16 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
              </svg>
            </div>
            <h2 className="text-xl font-semibold text-gray-800 mb-2">You've been unsubscribed</h2>
            <p className="text-gray-600">
              {contact?.email ? (
                <span><strong>{contact.email}</strong> has been removed from our outreach list.</span>
              ) : (
                <span>You have been removed from our outreach list.</span>
              )}
            </p>
            <p className="text-gray-500 text-sm mt-4">You will no longer receive outreach emails from VinoSeeker.</p>
          </div>
        )}

        {status === 'error' && (
          <div>
            <div className="mb-4 text-red-500">
              <svg className="w-16 h-16 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </div>
            <h2 className="text-xl font-semibold text-gray-800 mb-2">Something went wrong</h2>
            <p className="text-gray-600">This unsubscribe link is invalid or has expired.</p>
          </div>
        )}
      </div>
    </div>
  );
}
